import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import { useDownload } from "@/hooks/useDownload";
import { Loader2 } from "lucide-react";
import { AiFillApple } from "react-icons/ai";
import ContactEmail from "@/components/landing/ContactEmail";
import LanguageSwitcher from "@/components/landing/LanguageSwitcher";
import { useLanding } from "@/components/landing/i18n";

const Navbar = () => {
  const { language } = useI18n();
  const { t } = useLanding();
  const { isLoading, downloadLatest } = useDownload();
  // Past the top of the page the header tightens into a slim product bar.
  const [compact, setCompact] = useState(false);
  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={compact ? "compact" : undefined}>
      <div className="wrap nav">
        <a className="brand" href="#top">
          <img src="/landing/estha-icon-128.png" alt="Estha" />
          <b>Estha</b>
          <small>for Mac</small>
        </a>
        <nav className="nav-links">
          <a href="#chat">{t.nav.chat}</a>
          <a href="#build">{t.nav.build}</a>
          <a href="#agentic">{t.nav.agentic}</a>
          <a href="#org">{t.nav.org}</a>
          <a href="#private">{t.nav.privacy}</a>
          <a href="#pricing">{t.nav.pricing}</a>
          <ContactEmail className="nav-contact">{t.nav.contact}</ContactEmail>
        </nav>
        <div className="nav-right">
          <LanguageSwitcher />

            <Button
              size="sm"
              className="bg-[#1E88C8] hover:bg-[#1670A8] text-white"
              onClick={downloadLatest}
              disabled={isLoading}
            >
              {isLoading ? (
                <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />
              ) : (
                <AiFillApple className="mr-1 h-4 w-4" />
              )}
              {language === 'en' ? 'Download' : '下载'}
            </Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
